export default __webpack_public_path__ + "static/media/downloadArrow.9fc1382d.svg";